import { CampaignTypes } from "data/campaigns/constants";

export default class CreateDirectMailHandler {
  constructor(userId, marketingCampaign, marketingProfile, createDirectMailCampaign, getMarketingProfile) {
    this.userId = userId;
    this.marketingCampaign = marketingCampaign;
    this.marketingProfile = marketingProfile;
    this.createDirectMailCampaign = createDirectMailCampaign;
    this.getMarketingProfile = getMarketingProfile;
  }

  convertMarketingProfileToSenderSnapshotJson(marketingProfile) {
    return {
      fullName: marketingProfile.businessFullName,
      address: marketingProfile.businessFullStreetAddress ?? [marketingProfile.businessAddressLine1, marketingProfile.businessAddressLine2].filter(Boolean).join(", "),
      city: marketingProfile.businessCity,
      state: marketingProfile.businessState,
      zip: String(marketingProfile.businessZipCode),
      phone: marketingProfile.businessPhone,
      website: marketingProfile.businessWebsite,
      logo: marketingProfile.marketingProfilePicture,
    };
  }

  async run() {
    const marketingProfileForSenderSnapshot = this.marketingProfile ?? await this.getMarketingProfile(this.userId);

    return await this.createDirectMailCampaign({
      name: "New Direct Mail Campaign",
      originatingListName: this.marketingCampaign.name,
      marketingCampaignId: this.marketingCampaign.id,
      contactIds: this.marketingCampaign.contactIds,
      senderSnapshotJson: JSON.stringify(this.convertMarketingProfileToSenderSnapshotJson(marketingProfileForSenderSnapshot))
    });
  }
}
